import { useEffect, useState } from 'react';

export default function PricingHero() {
  const [animated, setAnimated] = useState(false);
  const [currentBg, setCurrentBg] = useState(0);

  useEffect(() => {
    setAnimated(true);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBg((prev) => (prev + 1) % 4);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const backgrounds = [
    'https://readdy.ai/api/search-image?query=financial%20market%20calculations%20spreadsheet%20with%20numbers%20and%20percentages%20showing%20savings%20and%20discounts%20clean%20minimal%20light%20background%20professional%20business%20analytics%20dashboard%20view&width=1920&height=1080&seq=pricingbg1&orientation=landscape',
    'https://readdy.ai/api/search-image?query=currency%20bills%20and%20coins%20arranged%20neatly%20showing%20value%20and%20savings%20light%20bright%20background%20financial%20success%20money%20management%20clean%20professional%20setup&width=1920&height=1080&seq=pricingbg2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=people%20celebrating%20getting%20great%20deal%20handshake%20agreement%20success%20light%20bright%20background%20professional%20business%20meeting%20happy%20clients%20winning&width=1920&height=1080&seq=pricingbg3&orientation=landscape',
    'https://readdy.ai/api/search-image?query=first%20in%20line%20concept%20queue%20priority%20access%20exclusive%20opportunity%20light%20background%20professional%20business%20advantage%20early%20access%20vip%20treatment&width=1920&height=1080&seq=pricingbg4&orientation=landscape'
  ];

  return (
    <section className="relative min-h-[70vh] flex items-center overflow-hidden bg-[#09090b]">
      {backgrounds.map((bg, index) => (
        <div
          key={index}
          className="absolute inset-0 transition-opacity duration-2000"
          style={{
            opacity: currentBg === index ? 0.15 : 0,
            backgroundImage: `url(${bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/20"></div>

      <div className="relative z-10 w-full">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-8 py-16 sm:py-24 lg:py-32">
          <div className="max-w-[900px] mx-auto text-center space-y-4 sm:space-y-6 lg:space-y-8">
            <h1
              className={`text-white text-[36px] sm:text-[48px] lg:text-[68px] font-black leading-[1.05] transition-all duration-700 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
            >
              Founder Pricing
            </h1>

            <p
              className={`text-[#d4d4d8] text-[18px] sm:text-[20px] lg:text-[24px] leading-relaxed transition-all duration-700 delay-200 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              The legal AI lawyers have been waiting for. Private. Mobile. Affordable
            </p>

            <div
              className={`space-y-3 sm:space-y-4 transition-all duration-700 delay-400 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <p className="text-white text-[16px] sm:text-[18px] lg:text-[20px] font-semibold">
                We're launching soon and opening early access to 500 founding members
              </p>
              <p className="text-[#06b6d4] text-[16px] sm:text-[18px] lg:text-[20px] font-bold">
                Lock in the lowest price we'll ever offer. Keep it forever
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
